<template>
	<section class="container container_main-content">
		<div class="verification verification__wrapper flex-vertical">
			<div class="verification__section verification__message">
				<div class="verification__header">
					<h2 class="heading heading-title">{{ $t('profile.unverifed.unverifed_account') }}</h2>
				</div>
				<div class="verification__content">
					<p class="verification__content-heading verification__content-item heading heading-subtitle">
						{{ $t('profile.unverifed.thanks') }}
					</p>
					<p class="verification__content-item heading heading-subtitle">
						{{ $t('profile.unverifed.mail') }} <span class="case-original bold">{{ user.email }}</span>
						{{ $t('profile.unverifed.we_sent') }}
					</p>
					<p class="verification__content-item heading heading-subtitle">{{ $t('profile.unverifed.please_confirm') }}</p>
				</div>
			</div>
			<div class="verification__section verification__controls">
				<v-button native-type="button" :loading="loading" @click="send">
					{{ $t('profile.unverifed.again_send') }}
				</v-button>
			</div>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	middleware: 'auth',
	name: 'UnverifedProfile',
	layout: 'index',

	metaInfo() {
		return { title: this.user.name }
	},

	data() {
		return {
			loading: false,
		}
	},

	created() {
		if (this.user.state === 'verifed') {
			this.$router.push({ name: 'profile' })
		}
	},

	computed: mapGetters({
		user: 'auth/user',
	}),

	methods: {
		async send() {
			this.loading = true
			try {
				let { data } = await this.$http.post('/verification/resend')
				this.$notify(data, 'success')
			} catch ({ response }) {
				this.$notify(response.data.message)
			}
			this.loading = false
		},
	},
}
</script>

<style scoped></style>
